/***********************************************************************************************************************
 *
 * @param hexOrRGB
 * @returns {string}
 **********************************************************************************************************************/
export const lightOrDark = (hexOrRGB) => {
    let color = hexOrRGB;
    if (typeof color !=='object') {
        if ( !color.match ( /^rgb/ ) ) {
            color = hexToRgb ( color );
        }
        const colorArr = color.replace ( 'rgb', '' ).replace ( 'a', '' ).replace ( '(', '' ).replace ( ')', '' ).split ( ',' );
        let r, g, b;
        r = colorArr[ 0 ];
        g = colorArr[ 1 ];
        b = colorArr[ 2 ];

        let hsp = Math.sqrt (
            0.299 * ( r * r ) +
            0.587 * ( g * g ) +
            0.114 * ( b * b )
        );

        if ( hsp > 127.5 ) {
            return 'light';
        } else {
            return 'dark';
        }
    } else {
        return  'dark';
    }
};

/***********************************************************************************************************************
 *
 * @param hex
 * @returns {string}
 **********************************************************************************************************************/
export const hexToRgb = (hex) => {
    let c;
    if (/^#([A-Fa-f0-9]{4}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')';
    }
    return 'rgb(0,0,0)';
};

/***********************************************************************************************************************
 *
 * @param rgb
 * @returns {*}
 **********************************************************************************************************************/
export const invertColor = (rgb)=> {
    rgb = Array.prototype.join.call(arguments).match(/(-?[0-9\.]+)/g);
    for (let i = 0; i < rgb.length; i++) {
        rgb[i] = (i === 3 ? 1 : 255) - rgb[i];
    }
    return rgb;
};

